var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMediumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5623 11.6917C22.5623 17.9648 17.5116 23.0504 11.281 23.0504C5.05037 23.0504 0 17.9663 0 11.6917C0 5.41701 5.05076 0.333313 11.281 0.333313C17.5112 0.333313 22.5623 5.41855 22.5623 11.6917ZM34.9381 11.6917C34.9381 17.5971 32.4126 22.3839 29.2975 22.3839C26.1823 22.3839 23.6568 17.5955 23.6568 11.6917C23.6568 5.78782 26.1823 0.999469 29.2975 0.999469C32.4126 0.999469 34.9381 5.78782 34.9381 11.6917ZM40 11.6917C40 16.9826 39.1117 21.2714 38.0161 21.2714C36.9205 21.2714 36.0322 16.9811 36.0322 11.6917C36.0322 6.40227 36.9205 2.1119 38.0165 2.1119C39.1124 2.1119 40 6.40112 40 11.6917Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumLogo);
export default __webpack_public_path__ + "static/media/mediumLogo.e2e0f2acd9a15945cb2e6d81d1989081.svg";
export { ForwardRef as ReactComponent };